module.exports = __webpack_public_path__ + "static/assets/0e7c63d93e28be97a36696f8a1528c4c.jpg";